import type { FC } from "react";

import { EditOrgUserForm } from "components/forms/EditOrgUserForm";
import type { OrgUserType, UserType } from "components/server-types";
import { t } from "i18n/i18n";
import { Dialog } from "mds/components/Dialog";

type EditOrgUserModalProps = {
  user: UserType &
    OrgUserType & {
      org_user_id: string;
    };
  open: boolean;
  onClose: () => void;
};

export const EditOrgUserModal: FC<EditOrgUserModalProps> = ({ user, open, onClose }) => (
  <Dialog
    open={open}
    title={<span className="font-bold">{t("user_options_menu.edit_user_info.title")}</span>}
    onClose={onClose}
  >
    <EditOrgUserForm className="pt-5" user={user} onClose={onClose} />
  </Dialog>
);
